import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { ReactComponent as AttachmentIcon } from "../../../common/icons/attachment.svg";

import { ACCEPTED_ATTACHMENT_TYPES } from "../constants";
import { InvoiceAttachmentsButton } from "../styled";

interface Props {
  invoiceNumber?: string;
  customer?: string;
  addAttachment?: (attachment: File) => void;
}

export const InvoiceHeader = ({
  invoiceNumber,
  customer,
  addAttachment,
}: Props) => {
  const { t } = useTranslation("invoices");
  const isNewInvoice = !invoiceNumber;
  return (
    <Box
      sx={{
        marginLeft: "5px",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Box>
        <Typography
          variant="header"
          sx={{
            fontSize: "14px",
            fontWeight: 700,
            textTransform: "uppercase",
          }}
        >
          {customer}
        </Typography>
        <Typography variant="header" sx={{ fontSize: "32px", fontWeight: 600 }}>
          {isNewInvoice
            ? t("addNewInvoice")
            : `${t("editInvoice")} ${invoiceNumber}`}
        </Typography>
      </Box>
      {addAttachment ? (
        <Box hidden={isNewInvoice}>
          <InvoiceAttachmentsButton
            variant="text"
            startIcon={<AttachmentIcon />}
            component="label"
          >
            <input
              type="file"
              accept={ACCEPTED_ATTACHMENT_TYPES.toString()}
              hidden
              onChange={(event) => {
                const files = event.target.files;
                if (files) addAttachment(files[0]);
              }}
            />
            {t("addAttachment", { ns: "common" })}
          </InvoiceAttachmentsButton>
        </Box>
      ) : null}
    </Box>
  );
};
